/**
 * @generated SignedSource<<5591d6950a8c34d501bab79270c3e936>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionItemLinkageModalItem$data = {
  readonly childBlocks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly hasAccessToNote: boolean;
        readonly id: string;
        readonly note: {
          readonly id: string;
          readonly stream: {
            readonly id: string;
            readonly isTodoStream: boolean;
          };
        };
        readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalNoteInfo">;
      } | null;
    } | null>;
  };
  readonly hasAccessToNote: boolean;
  readonly id: string;
  readonly note: {
    readonly id: string;
    readonly stream: {
      readonly id: string;
      readonly isTodoStream: boolean;
    };
  };
  readonly numNoAccess: number;
  readonly originalBlock: {
    readonly childBlocks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly hasAccessToNote: boolean;
          readonly id: string;
          readonly note: {
            readonly id: string;
            readonly stream: {
              readonly id: string;
              readonly isTodoStream: boolean;
            };
          };
          readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalNoteInfo">;
        } | null;
      } | null>;
    };
    readonly hasAccessToNote: boolean;
    readonly id: string;
    readonly note: {
      readonly id: string;
      readonly stream: {
        readonly id: string;
        readonly isTodoStream: boolean;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalNoteInfo">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalNoteInfo">;
  readonly " $fragmentType": "ActionItemLinkageModalItem";
};
export type ActionItemLinkageModalItem$key = {
  readonly " $data"?: ActionItemLinkageModalItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccessToNote",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "note",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTodoStream",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ActionItemLinkageModalNoteInfo"
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteBlockConnection",
  "kind": "LinkedField",
  "name": "childBlocks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteBlockEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteBlock",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionItemLinkageModalItem",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numNoAccess",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "originalBlock",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/),
    (v3/*: any*/)
  ],
  "type": "NoteBlock",
  "abstractKey": null
};
})();

(node as any).hash = "1298197c0957ff005728f716c26411ba";

export default node;
